import { Box, IconButton } from '@mui/material';
import { TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

export default function QuantityEditor({ value, onChange }) {
  return (
    <Box
      sx={{
        display: 'flex',
        width: 140,
        border: '1px solid #d7dce1',
        borderRadius: 1,
        overflow: 'hidden',
      }}
    >
      <IconButton size='small' onClick={() => onChange(Math.max(0, value - 1))}>
        <RemoveIcon fontSize='small' />
      </IconButton>

      <TextField
        value={value}
        onChange={(e) => {
          const val = e.target.value;

          // allow empty while typing
          if (val === '') {
            onChange('');
            return;
          }

          // only numbers
          if (/^\d+$/.test(val)) {
            onChange(Number(val));
          }
        }}
        onBlur={() => {
          if (value === '' || isNaN(value)) {
            onChange(0);
          }
        }}
        inputProps={{
          style: {
            textAlign: 'center',
            padding: '6px',
          },
        }}
        sx={{
          flex: 1,
          fontWeight: 600,
          fontSize: 14,
        }}
      />

      <IconButton size='small' onClick={() => onChange(Number(value || 0) + 1)}>
        <AddIcon fontSize='small' />
      </IconButton>

      <Box
        sx={{
          px: 1,
          borderLeft: '1px solid #d7dce1',
          display: 'flex',
          alignItems: 'center',
          fontSize: 12,
          color: 'text.secondary',
        }}
      >
        pcs
      </Box>
    </Box>
  );
}
